import type {AddMaterialNoteFormPayload} from "./add-material-note.schema";

import {addMaterialNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../../../material-keys";

export function addMaterialNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: materialMutationKeys.addMaterialNote,
    mutationFn: (payload: AddMaterialNoteFormPayload) => addMaterialNote(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
